export type InfoAction =
  | {
      type: "INFO_SUCCESS";
      payload: [message: string, duration:number];
    }
  | {
      type: "INFO_ERROR";
      payload: [message: string, duration:number];
    }
  | {
      type: "INFO_WARN";
      payload: [message: string, duration:number];
    }
  | {
      type: "ON_CLOSE_INFO_DISPLAY";
      payload: [];
    };

function openInforSuccess(message: string, duration:number): InfoAction {
  return {
    type: "INFO_SUCCESS",
    payload: [message, duration],
  };
}

function openInforError(message: string, duration:number): InfoAction {
  return {
    type: "INFO_ERROR",
    payload: [message, duration],
  };
}

function openInforWarn(message: string, duration:number): InfoAction {
  return {
    type: "INFO_WARN",
    payload: [message, duration],
  };
}

function closeInfor(): InfoAction {
  return {
    type: "ON_CLOSE_INFO_DISPLAY",
    payload: [],
  };
}

export const InfoActions = {
  openInforSuccess,
  openInforError,
  openInforWarn,
  closeInfor,
};
